module.exports = __webpack_public_path__ + "img/schema3_2x.98a7c569.webp";